import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { AlertTriangle, X } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const TranslationDisclaimer = () => {
  const { currentLanguage } = useLanguage();
  const [isDismissed, setIsDismissed] = useState(() => {
    return localStorage.getItem('translationDisclaimerDismissed') === 'true';
  });

  const handleDismiss = () => {
    setIsDismissed(true);
    localStorage.setItem('translationDisclaimerDismissed', 'true');
  };

  // Reset dismissal when language changes back to English
  React.useEffect(() => {
    if (currentLanguage === 'en') {
      localStorage.removeItem('translationDisclaimerDismissed');
      setIsDismissed(false);
    }
  }, [currentLanguage]);

  // Don't show for English or if dismissed
  if (currentLanguage === 'en' || isDismissed) {
    return null;
  }

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-yellow-500 to-orange-500 shadow-lg"
      >
        <div className="max-w-7xl mx-auto px-4 py-3">
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <AlertTriangle size={20} className="text-white flex-shrink-0" />
              <p className="text-sm text-white font-medium">
                <span className="font-bold">Translation Notice:</span> Content is auto-translated and may contain inaccuracies. For best experience, please use English.
              </p>
            </div>
            <button
              onClick={handleDismiss}
              className="flex-shrink-0 p-1 hover:bg-white/20 rounded-full transition-colors"
              aria-label="Dismiss"
            >
              <X size={18} className="text-white" />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default TranslationDisclaimer;
